const baseAPIUrl =
  "https://1ooda0of9l.execute-api.eu-west-1.amazonaws.com/DEV/data-api";
const config = {
  urls: {
    baseUrl: baseAPIUrl,
    catalogue: {
      listCatalogs: baseAPIUrl + "/catalogue/listCatalogs",
      getDataSets: baseAPIUrl + "/catalogue/getDataSets",
    },
    data: {
      getFilterOperators: baseAPIUrl + "/data/filter-operators",
      getDataTypes: baseAPIUrl + "/data/data-types",
      getData: baseAPIUrl + "/data",
    },
  },
  metaCat: {
    v_data_cat: "70",
    v_data_desc_cat: "93",
    v_field_cat: "75",
    v_field_publish_cat: "82",
    v_data_reference_cat: "94",
    v_provider_cat: "76",
    v_spatial_cat: "92",
    v_validation_cat: "79",
    v_update_cat: "73",
    v_al_cat: "84",
    v_update_log: "89",
    v_licence_cat: "71",
    v_schema: "68",
    v_data_name: "74",
    v_region: "90",
    v_dataset_type: "88",
    v_data_status: "91",
    v_team: "77",
    v_reference_type: "78",
    v_update_method: "87",
    v_time: "80",
    v_update_type: "69",
    v_project: "85",
    v_ethical_level: "83",
    v_units: "86",
    v_standard_field: "67",
  },
};

export default config;
